// extracted by mini-css-extract-plugin
export default {"join":"join_join__HfgG6","join__inner-title":"join_join__inner-title__XNY+s","join__inner-foot":"join_join__inner-foot__Wwz4r"};